import { render, staticRenderFns } from "./ClientViewDashboard.vue?vue&type=template&id=524b9943&scoped=true&"
import script from "./ClientViewDashboard.vue?vue&type=script&lang=js&"
export * from "./ClientViewDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b9943",
  null
  
)

export default component.exports